import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-tips.png'


const _withScopeId = n => (_pushScopeId("data-v-a86b945e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "apply-pdo-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))

import { useI18n } from 'vue-i18n';
  import { authStore } from '@/stores';
  import { useRouter } from 'vue-router';
  import { IProgram } from '@/types/program';
  import { request, confirm } from '@/utils';
  import { ColorVariants } from '@/constants';
  import { useToast } from 'bootstrap-vue-3';

  interface IProps {
    program: IProgram;
  }


  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
    program: IProgram;
  }

  
  const { t } = useI18n();
  const toast = useToast();

  const router = useRouter();
  async function apply() {
    if (!props.program.participation_request_id) {
      await confirm('', { content: t('participate.join_content') });
      await request.post(`programs/${props.program.id}/participate`, {}, { loading: { silent: true } });
      await toast.show({ title: t('Success'), body: t('participate.join_success_content') }, { variant: ColorVariants.success });
    }
    await authStore.fetchData();
    router.push({ name: 'pdo.apply-to-be-form', params: { id: props.program.id } });
  }

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "apply-button",
      onClick: apply
    }, _toDisplayString(_unref(t)('button_text')), 1),
    _withDirectives((_openBlock(), _createBlock(_component_b_button, {
      title: _unref(t)('btn_tips'),
      class: "reset-btn"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["title"])), [
      [
        _directive_b_tooltip,
        void 0,
        void 0,
        { hover: true }
      ]
    ])
  ]))
}
}

})